export default {"src":"/_next/static/media/building-percentage.344f58b0.svg","height":441,"width":703,"blurWidth":0,"blurHeight":0};